<script setup lang="ts">
import { ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import { useI18n } from 'vue-i18n'

defineProps<{ rowData: any }>()
const value = ref(false)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
</script>
<template>
  <template v-if="rowData.pl_info?.length == 1">
    {{ rowData.pl_info[0].pl_short_name }}
  </template>
  <template v-else-if="rowData.pl_info?.length > 1">
    <span class="text-primary underline cursor-pointer" @click="value = true">
      {{ rowData.pl_info.length }}
    </span>
  </template>
  <BaseModal v-model="value">
    <template #title>{{ rowData.description }} Product Lines</template>
    <template #content>
      <div v-for="pl of rowData.pl_info" :key="pl">
        {{ pl.pl_short_name }} / {{ pl.pl_description }}
      </div>
    </template>
    <template #actions>
      <q-btn rounded flat :label="label('close')" v-close-popup />
    </template>
  </BaseModal>
</template>
